import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useStoreConfig } from "@hooks/use-store-info";
type Params = {
  type: "BreadcrumbList";
  data: Breadcrumb[];
} | {
  type: "Organization";
  data: null;
} | {
  type: "WebSite";
  data: null;
} | {
  type: "FAQPage";
  data: FAQPage[];
} | {
  type: "Product";
  data: Product;
};
type Breadcrumb = {
  link: string;
  title: string;
};
type FAQPage = {
  name: string;
  text: string;
};
type Product = {
  name: string;
  description: string;
  image: string;
  brand: string;
  offers: {
    lowPrice: number;
    highPrice: number;
    offerCount: number;
  } | {
    url: string;
    price: string | number;
  };
};
export const useMicroMarkup = t0 => {
  const $ = _c(33);
  const {
    type,
    data
  } = t0;
  const {
    storeName,
    phone
  } = useStoreConfig();
  let t1;
  bb0: {
    if (type === "BreadcrumbList") {
      let t2;
      let t3;
      if ($[0] !== data || $[1] !== type) {
        const prepareData = data.map(_temp);
        t2 = type;
        t3 = JSON.stringify(prepareData);
        $[0] = data;
        $[1] = type;
        $[2] = t2;
        $[3] = t3;
      } else {
        t2 = $[2];
        t3 = $[3];
      }
      const t4 = `{
            "@context": "https://schema.org/",
            "@type": "${t2}",
            "itemListElement": ${t3}
          }`;
      let t5;
      if ($[4] !== t4) {
        t5 = {
          __html: t4
        };
        $[4] = t4;
        $[5] = t5;
      } else {
        t5 = $[5];
      }
      t1 = t5;
      break bb0;
    }
    if (type === "Organization") {
      let t2;
      if ($[6] !== phone || $[7] !== storeName || $[8] !== type) {
        const prepareData_0 = {
          "@context": "https://schema.org/",
          "@type": type,
          name: storeName,
          url: "https://t2.ru/",
          email: "support@t2.ru",
          telephone: phone,
          address: {
            "@type": "PostalAddress",
            addressLocality: "\u041C\u043E\u0441\u043A\u0432\u0430,\u0420\u043E\u0441\u0441\u0438\u044F",
            postalCode: "123290",
            streetAddress: "\u043C\u0443\u043D\u0438\u0446\u0438\u043F\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u043A\u0440\u0443\u0433 \u0425\u043E\u0440\u043E\u0448\u0435\u0432\u043E-\u041C\u043D\u0435\u0432\u043D\u0438\u043A\u0438, \u041F\u0440\u0438\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u0435\u0437\u0434, \u0434\u043E\u043C 2, \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435 XVIII 3 \u044D\u0442\u0430\u0436 \u043A\u043E\u043C. 17"
          }
        };
        t2 = JSON.stringify(prepareData_0);
        $[6] = phone;
        $[7] = storeName;
        $[8] = type;
        $[9] = t2;
      } else {
        t2 = $[9];
      }
      let t3;
      if ($[10] !== t2) {
        t3 = {
          __html: t2
        };
        $[10] = t2;
        $[11] = t3;
      } else {
        t3 = $[11];
      }
      t1 = t3;
      break bb0;
    }
    if (type === "WebSite") {
      let t2;
      if ($[12] !== storeName || $[13] !== type) {
        const prepareData_1 = {
          "@context": "https://schema.org",
          "@type": type,
          url: "https://t2.ru/",
          name: storeName,
          potentialAction: {
            "@type": "SearchAction",
            target: "https://t2.ru/search?s={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        };
        t2 = JSON.stringify(prepareData_1);
        $[12] = storeName;
        $[13] = type;
        $[14] = t2;
      } else {
        t2 = $[14];
      }
      let t3;
      if ($[15] !== t2) {
        t3 = {
          __html: t2
        };
        $[15] = t2;
        $[16] = t3;
      } else {
        t3 = $[16];
      }
      t1 = t3;
      break bb0;
    }
    if (type === "FAQPage") {
      let t2;
      if ($[17] !== data || $[18] !== type) {
        const prepareData_2 = {
          "@context": "https://schema.org",
          "@type": type,
          mainEntity: data?.map(_temp2)
        };
        t2 = JSON.stringify(prepareData_2);
        $[17] = data;
        $[18] = type;
        $[19] = t2;
      } else {
        t2 = $[19];
      }
      let t3;
      if ($[20] !== t2) {
        t3 = {
          __html: t2
        };
        $[20] = t2;
        $[21] = t3;
      } else {
        t3 = $[21];
      }
      t1 = t3;
      break bb0;
    }
    if (type === "Product") {
      const t2 = "lowPrice" in data.offers ? "AggregateOffer" : "Offer";
      let t3;
      if ($[22] !== data.brand || $[23] !== data.description || $[24] !== data.image || $[25] !== data.name || $[26] !== data.offers || $[27] !== t2 || $[28] !== type) {
        const offersData = {
          "@type": t2,
          priceCurrency: "RUB",
          ...data.offers
        };
        if ("Offer" in data.offers) {
          offersData.availability = "https://schema.org/InStock";
        }
        const prepareData_3 = {
          "@context": "https://schema.org",
          "@type": type,
          name: data.name,
          description: data.description,
          image: [data.image],
          brand: {
            "@type": "Brand",
            name: data.brand
          },
          offers: offersData
        };
        t3 = JSON.stringify(prepareData_3);
        $[22] = data.brand;
        $[23] = data.description;
        $[24] = data.image;
        $[25] = data.name;
        $[26] = data.offers;
        $[27] = t2;
        $[28] = type;
        $[29] = t3;
      } else {
        t3 = $[29];
      }
      let t4;
      if ($[30] !== t3) {
        t4 = {
          __html: t3
        };
        $[30] = t3;
        $[31] = t4;
      } else {
        t4 = $[31];
      }
      t1 = t4;
      break bb0;
    }
    let t2;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        __html: ""
      };
      $[32] = t2;
    } else {
      t2 = $[32];
    }
    t1 = t2;
  }
  return t1;
};
function _temp(item, index) {
  return {
    "@type": "ListItem",
    position: index + 1,
    item: {
      "@id": item.link,
      name: item.title
    }
  };
}
function _temp2(item_0) {
  return {
    "@type": "Question",
    name: item_0.name,
    acceptedAnswer: {
      "@type": "Answer",
      text: item_0.text
    }
  };
}